import { useSettings } from './useSetting';

export function useHighlightCorners(): [
	boolean,
	(value: boolean | undefined) => void,
] {
	const { settings, setValue } = useSettings();
	const highlightCorners = settings.highlightCorners ?? false;
	const setHighlightCorners = (value: boolean | undefined) =>
		setValue('highlightCorners', value);
	return [highlightCorners, setHighlightCorners];
}
